import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { AnredeArtApi } from './InterfacesAnredeArtApi';
import { AddressApi } from './PersonAddressApi';

/**
 * APIL Url: ADAC.Internet.Types.Person.AbweichenderKontoInhaber
 * 
 * Endpoints: /api/BankOperation/update, /api/v2/versicherungen/fahrrad/anlage, /api/haustier/anlage, /api/Identity, /api/ps/anlage, /api/rrv/anlage, /api/rrv/anlageextern, /api/us/anlage, /api/versicherungen/aksbep/anlage, /api/versicherungen/aks/anlageextern, /api/versicherungen/akslangzeit/anlage, /api/versicherungen/incoming/anlage, /api/versicherungen/brs/anlage, /api/versicherungen/phv/anlage, /api/versicherungen/us/anlage, /api/versicherungen/ps/anlage, /api/v2/versicherungen/rrv/anlage, /api/v2/versicherungen/rrv/anlageextern, /api/zuhause/hausrat/anlage, /api/zuhause/schutzbrief/anlage
 */
export class AbweichenderKontoInhaberApi extends BaseApiModel {
	constructor(initialProperties?: Partial<AbweichenderKontoInhaberApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected anredeKennzeichen: AnredeArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.AnredeArt
	 */
	get AnredeKennzeichen(): AnredeArtApi {
		return this.anredeKennzeichen;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.AnredeArt
	 */
	set AnredeKennzeichen(value: AnredeArtApi) {
		this.anredeKennzeichen = value;
	}

	protected titel: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Titel(): string {
		return this.titel;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Titel(value: string) {
		this.titel = value;
	}

	protected vorname: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Vorname(): string {
		return this.vorname;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Vorname(value: string) {
		this.vorname = value;
	}

	protected name: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Name(): string {
		return this.name;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Name(value: string) {
		this.name = value;
	}

	protected adresse: AddressApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Address
	 */
	get Adresse(): AddressApi {
		return this.adresse;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Address
	 */
	set Adresse(value: AddressApi) {
		this.adresse = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AbweichenderKontoInhaberApi {
		return AppUtils.Helper.createFromMap(dataObject, AbweichenderKontoInhaberApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'adresse':
					return AddressApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.AnredeKennzeichen = this.anredeKennzeichen;
		result.Titel = this.titel;
		result.Vorname = this.vorname;
		result.Name = this.name;
		if (this.adresse) {
			result.Adresse = this.adresse.toRequestObject();
		}
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}